import { forwardRef, type PropsWithChildren } from 'react';
import { Popover } from 'antd';
import type { TooltipRef } from 'antd/es/tooltip';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/modules/ui';

import * as felaRules from './GeneratorButtonPopover.rules';

export interface GeneratorButtonPopoverProps extends PropsWithChildren {
    isOpen: boolean;
    openPasswordGenerator: () => void;
}

export const GeneratorButtonPopover = forwardRef<TooltipRef, GeneratorButtonPopoverProps>(
    ({ isOpen, openPasswordGenerator, children }, ref) => (
        <Popover
            ref={ref}
            content={
                <Button
                    type='text'
                    onClick={() => openPasswordGenerator()}
                    color='foregroundsPrimary'
                    customStyle={felaRules.generatePasswordButton}
                    data-testid='generator-button-popover'
                >
                    <FormattedMessage id='passwordGenerator' />
                </Button>
            }
            open={isOpen}
            placement='bottomRight'
            arrow={false}
            zIndex={0}
            styles={{ container: felaRules.popover }}
            align={{ offset: [0, 0] }}
        >
            {children}
        </Popover>
    ),
);
